import React, { Component } from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'

class VehicleList extends Component {
  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => this.props.onShowVehicle(original)}>{value}</a>,
    },
    {
      Header: 'Vehicle Name',
      accessor: 'description',
    },
    {
      Header: 'account',
      accessor: 'salik.account',
    },

    {
      Header: 'ermirate',
      accessor: 'salik.ermirate',
    },
    {
      Header: 'chasis',
      accessor: 'salik.chasis',
    },
    {
      Header: 'category',
      accessor: 'salik.category',
    },

    {
      Header: 'plate',
      accessor: 'salik.plate',
    },
    {
      Header: 'tag',
      accessor: 'salik.tag',
    },
    {
      Header: 'year',
      accessor: 'salik.year',
    },
    {
      Header: 'company',
      accessor: 'company.fn',
    },
  ]

  render() {
    const { vehicles, fetchVehicles, fetchingVehicles } = this.props
    return <CustomTable columns={this.columns} data={vehicles} fetch={fetchVehicles} fetching={fetchingVehicles} />
  }
}

VehicleList.propTypes = {}
VehicleList.defaultProps = {}

export default VehicleList
